<div class="card">
  <div class="card-body">
    <div class="card-body" *ngIf="loading">
      <div class="k-i-loading ml-1 mr-1" style="font-size: 40px;"></div>
    </div>

    <kendo-grid
                [data]="gridDataResult"
                [loading]="carregando" style="min-height: 300px;"
                [scrollable]="false"
                footerStyle="font-size: 11px;"
                [group]="groups"
                [groupable]="true"
                (edit)="editar($event)"
                (remove)="abraDialogRemover($event)">
      <ng-template kendoGridToolbarTemplate [position]="'top'">
        <button class="btn btn-blue" (click)="novo(false)">
          <i class="fe-plus "></i>
          Nova Forma de Pagamento
        </button>
        <button class="btn btn-warning" (click)="novo(true)">
          <i class="fe-plus  1"></i>
          Nova Forma de Pagamento Online
        </button>

        <div class="mt-1" >
          <span #pagarmehub id="pagarme-hub" class="mb-2 "></span>

          <div class="form-group mb-3  " *ngIf="empresa.integracaoGatewayPagamento?.sandbox">
            <span class="badge badge-danger">Sandbox - Teste</span>
          </div>
        </div>

      </ng-template>
      <kendo-grid-messages
        pagerPage="Página"
        pagerOf="de"
        pagerItems="itens"
        noRecords="Nenhuma forma de pagamento"
        loading="Carregando"
        pagerItemsPerPage="ítems por página"
      >
      </kendo-grid-messages>
      <kendo-grid-column title="ID"    width="70">
        <ng-template kendoGridCellTemplate let-dataItem  >
          <span class="text-blue"><b>{{dataItem.id}}</b></span>
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column title="Descrição">
        <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
          <span><b>{{dataItem.descricao}}</b></span>
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column title="Pagamento" field="tipoDePagamento"  media="(min-width: 1300px)" width="200px">
        <ng-template kendoGridGroupHeaderTemplate let-value="value">
          {{value}}
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-column title=" {{'Referência ( ' +empresa?.integracaoDelivery?.sistema + ')'}}"   *ngIf="empresa.integracaoDelivery" >
        <ng-template kendoGridCellTemplate let-dataItem  >
          <ng-container *ngIf="dataItem.referenciaExterna">
            {{dataItem.referenciaExterna}}
             <ng-container *ngIf="dataItem.bandeirasCartaoIntegrada.length">
               (
                 <span *ngFor="let bandeira of dataItem.bandeirasCartaoIntegrada; let ultimo = last; ">
                      {{bandeira.nome}} <span *ngIf="!ultimo">, </span>
                 </span>
               )</ng-container>
          </ng-container>

          <span *ngIf="!dataItem.referenciaExterna" class="text-danger">
            <i class="fa fa-times "></i> nao configurada
          </span>

        </ng-template>
      </kendo-grid-column>

      <kendo-grid-column title="OpenDelivery"   *ngIf="empresa.integracaoOpendelivery?.ativa || empresa.integracaoOpendeliveryLogistica?.ativa" >
        <ng-template kendoGridCellTemplate let-dataItem  >
          <ng-container *ngIf="dataItem.opendeliveryMethod">
            {{dataItem.opendeliveryMethod}}
            <ng-container *ngIf="dataItem.opendeliveryBrand">
              ({{dataItem.opendeliveryBrand}})
            </ng-container>
          </ng-container>
          <span *ngIf="!dataItem.opendeliveryMethod" class="text-danger">
            <i class="k-icon k-i-error"></i> nao configurada
          </span>
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-column title="Exibir"  media="(min-width: 1300px)" width="150px">
        <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
          <span [class.sim]="dataItem.exibirCardapio" [class.nao]="!dataItem.exibirCardapio">{{dataItem.exibirCardapio ? 'Sim' : 'Não'}}</span>
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-column title="Taxa retorno"  media="(min-width: 1300px)" width="150px" *ngIf="temTaxaRetorno()">
        <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
          <span [class.sim]="dataItem.cobrarTaxaRetorno" [class.nao]="!dataItem.cobrarTaxaRetorno">{{dataItem.cobrarTaxaRetorno ? 'Sim' : 'Não'}}</span>
        </ng-template>
      </kendo-grid-column>


      <kendo-grid-command-column title="" width="100px">
        <ng-template kendoGridCellTemplate let-isNew="isNew" let-formaPagamento >
          <button kendoGridEditCommand [primary]="true" (selectedChange)="editar(formaPagamento)">
            <i class="fa fa-edit" kendoTooltip title="editar"></i>
          </button>
          <button kendoGridRemoveCommand kendoTooltip title="remover" *ngIf="formaPagamento.nome != 'cashback' " >
            <i class="fa fa-trash"></i></button>


        </ng-template>
      </kendo-grid-command-column>

      <div class="k-i-loading ml-1 mr-1" style="font-size: 40px;height: 400px;" *ngIf="carregando"></div>
    </kendo-grid>
  </div>
</div>

<kendo-dialog title="Confirmar a remoção" *ngIf="modalDeletar" (close)="close('cancel')" [minWidth]="250" [width]="450">
  <p style="margin: 30px; text-align: center;">Você tem certeza que deseja apagar a forma de pagamento <strong>{{formaApagar.descricao}}</strong>?</p>
  <kendo-dialog-actions>
    <button kendoButton (click)="close('sim')" primary="true">Sim</button>
    <button kendoButton (click)="close('nao')">Não</button>
  </kendo-dialog-actions>
</kendo-dialog>
